export default __webpack_public_path__ + "static/audio-cardio-5-h-8cc4e7a0530bc4f264beba452e96dcc3.webp";